(ns manage.content-configuration-page.context-source.poi
  (:require ["@mui/material/Stack$default" :as Stack]
            [cljs-bean.core :refer [->clj]]
            [common.queries :refer [query-client]]
            [common.resource.query.poi :as poi-query]
            [manage.content-configuration-page.context-source.shared :as cs]
            [manage.content-configuration-page.view.input :as view.input]
            [re-frame.core :as rf]))

(def schema-id "urn:lemonpi:schema:context:poi:v1")

;; database

(rf/reg-fx ::fetch-selectors!
  (fn [{:keys [advertiser-id]}]
    (-> (.fetchQuery query-client
                     (poi-query/selectors-query {:advertiser-id advertiser-id
                                                 :per-page 100}))
        (.then #(rf/dispatch [::fetch-selectors-success (->clj %)]))
        (.catch #(rf/dispatch [::fetch-selectors-failure])))))

(rf/reg-event-fx ::fetch-selectors
  [(rf/inject-cofx :sub :url-context)]
  (fn [{:keys [url-context]} _]
    {::fetch-selectors! {:advertiser-id (:advertiser-id url-context)}}))

(rf/reg-event-db ::fetch-selectors-success
  (fn [db [_ response]]
    (assoc db ::selectors
           (mapv (fn [selector]
                   {:label (poi-query/selector-label selector)
                    :value (:id selector)})
                 (:items response)))))

(rf/reg-event-db ::fetch-selectors-failure
  (fn [db _]
    (assoc db ::selectors [])))

(rf/reg-sub ::selector-options
  (fn [db _]
    (get db ::selectors [])))

(defmethod cs/parameter schema-id
  [context-source]
  (let [selector-id (:poi-context-source/selector-id context-source)
        max-radius-km (:poi-context-source/max-radius-km context-source)]
    (when selector-id
      {:selector-id selector-id
       :max-radius-km max-radius-km})))

(defmethod cs/context->constructor schema-id
  [{:keys [param]}]
  (when param
    {:poi-context-source/selector-id (:selector-id param)
     :poi-context-source/max-radius-km (:max-radius-km param)}))

;; UI

(defn choose-selector [pcs]
  [view.input/dropdown-save-on-change
   (-> (view.input/props-entity pcs :poi-context-source/selector-id)
       (assoc :dropdown/options-sub [::selector-options])
       (assoc-in [:control-props :disabled?] @(rf/subscribe [:resource.content-function-version/active-version? "published"]))
       (assoc-in [:form-field-props :label] "POI selector"))])

(defn max-radius-km [pcs]
  [view.input/input-save-on-blur
   (-> (view.input/props-input-integer pcs :poi-context-source/max-radius-km)
       (assoc-in [:control-props :disabled] @(rf/subscribe [:resource.content-function-version/active-version? "published"]))
       (assoc-in [:form-field-props :label] "Max distance (km)"))])

(defmethod cs/entity-view-cfg schema-id
  [pcs]
  (merge
   (cs/entity-view-cfg-base pcs)
   {:entity/read-only? false
    :entity/on-activate [[::fetch-selectors]]
    :list-item/details [cs/configure-button pcs "sensors" "Configure POI"]
    :entity/query-param [:context-source/query-params pcs]
    :entity/content
    [:> Stack {:p 3 :spacing 2}
     [choose-selector pcs]
     [max-radius-km pcs]]}))

(defmethod cs/entity-query-params schema-id
  [{:keys [alias]}]
  (cs/alias->entity-query-params alias))
